import { api } from './api'

export interface Badge {
  id: string; emoji: string; name: string; desc: string; unlockedAt: string | null
}
export interface TrailSummary {
  today: string; since: string | null
  totalMinutes: number; totalHours: number
  activeDays: number; doneDays: number; spanDays: number
  streak: { current: number; best: number }
  heat: { d: string; m: number; t: number }[]
  badges: Badge[]; unlocked: number; total: number
  modes: { mode: 'onscreen' | 'offscreen'; minutes: number; sessions: number; pct: number }[]
  passed: { day: string; kind: string; title: string; note: string | null; subject: string | null }[]
  scores: { id: number; score: string; taken_at: string | null; official: number
    subject: string; kind: string; target_score: string | null }[]
}

export const trailApi = { summary: () => api.get<TrailSummary>('/api/trail/summary') }

/** 「42.5 小时」在中文里读着别扭，拆成「42 小时 30 分」 */
export function fmtSpan(minutes: number): { big: string; unit: string; tail: string } {
  if (minutes < 60) return { big: String(minutes), unit: '分钟', tail: '' }
  const h = Math.floor(minutes / 60), m = minutes % 60
  return { big: String(h), unit: '小时', tail: m ? `${m} 分` : '' }
}

export const mdLabel = (day: string) => `${+day.slice(5, 7)} 月 ${+day.slice(8, 10)} 日`
